module.exports = __webpack_public_path__ + "static/img/nav_center_bgc.be63391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latast_pc/nav_center_bgc.png
// module id = cHLI
// module chunks = 98